import React, { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import api from "../../globals/axios";
import LoaderContainer from "../../components/LoaderContainer";
import { Typography } from "@mui/material";

const SoilMoistureGraph = ({ farmId, date, height = 400 }) => {
  const [probeData, setProbeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProbeData = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          `/satellitedata/get-farm-soil-moisture-probe-data/${farmId}/?date=${date}`
        );
        const processedData = {
          ...response.data,
          soil_moisture_levels: response.data.soil_moisture_levels.slice(-15),
        };
        setProbeData(processedData);
        setError(null);
      } catch (err) {
        console.error("Error fetching probe data:", err);
        setError("Failed to fetch soil moisture probe data");
      } finally {
        setLoading(false);
      }
    };

    if (farmId) {
      fetchProbeData();
    }
  }, [farmId]);

  if (loading) return <LoaderContainer loading={loading} />;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!probeData) return null;
  const data = probeData.soil_moisture_levels.map((ele) => {
    return {
      date: ele.date,
      "Current soil irrigation level": ele.soil_moisture_level,
      "Minimum required": ele.critical_soil_moisture_level,
      "Maximum advised":
        probeData.soil_moisture_reference_levels.field_capacity_level,
    };
  });

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          tick={{ angle: -45, textAnchor: "end" }}
          height={60}
          interval={1}
        />
        <YAxis
          tick={{ angle: 0, textAnchor: "end" }}
          height={60}
          interval={0}
          domain={[0.1, 0.4]}
        />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="Current soil irrigation level"
          stroke="#8884d8"
          strokeWidth={2}
        />
        <Line
          type="monotone"
          dataKey="Minimum required"
          stroke="red"
          strokeWidth={2}
        />
        <Line
          type="monotone"
          dataKey="Maximum advised"
          stroke="green"
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SoilMoistureGraph;
